import { render } from "./StakesSummary.vue?vue&type=template&id=a102ef3c&scoped=true&ts=true"
import script from "./StakesSummary.vue?vue&type=script&lang=ts"
export * from "./StakesSummary.vue?vue&type=script&lang=ts"

import "./StakesSummary.vue?vue&type=style&index=0&id=a102ef3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a102ef3c"]])

export default __exports__